import { render, staticRenderFns } from "./ToastCard.vue?vue&type=template&id=06526522&scoped=true"
import script from "./ToastCard.vue?vue&type=script&lang=js"
export * from "./ToastCard.vue?vue&type=script&lang=js"
import style0 from "./ToastCard.vue?vue&type=style&index=0&id=06526522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06526522",
  null
  
)

export default component.exports